import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=5bb6cacf&scoped=true"
import script from "./productDialog.vue?vue&type=script&lang=js"
export * from "./productDialog.vue?vue&type=script&lang=js"
import style0 from "./productDialog.vue?vue&type=style&index=0&id=5bb6cacf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6cacf",
  null
  
)

export default component.exports